import styles from "./style.module.css";

const NoData = () => {
    return <div className={styles.no_data}>No data found</div>;
};

export default NoData;
